import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ReactiveFormsModule} from '@angular/forms';
import {SelectFilterDataModule} from '../../../../../core/component/select-filter-data/select-filter-data.module';
import {ReportComponentSelectFilterComponent} from './report-component-select-filter.component';

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        SelectFilterDataModule,
    ],
    declarations: [
        ReportComponentSelectFilterComponent
    ],
    exports: [
        ReportComponentSelectFilterComponent
    ]
})
export class ReportComponentSelectFilterModule {
}
